



































import Vue from 'vue';
import { simpleInputDialog } from './SimpleInput';


export default Vue.extend({
  data: () => simpleInputDialog,
  computed: {
    focusFirst(): boolean {
      return this.visible && this.focus === 'first';
    },
    focusConfirm(): boolean {
      return this.visible && this.focus === 'confirm';
    },
  },
});
